enum Features {
  CONSENT_FORMS_AUTO_ADD_DETAILS = 'CONSENT_FORMS_AUTO_ADD_DETAILS',
  CVC_INTAKE_QUESTIONNAIRE = 'CVC_INTAKE_QUESTIONNAIRE',
  DEPOSIT_PAY_BY_LINK = 'DEPOSIT_PAY_BY_LINK',
  DEPOSIT_JUNE_FF_CVC_19621 = 'DEPOSIT_JUNE_FF_CVC_19621',
  DISPLAY_CONSENT_FORMS_ON_KIOSK = 'DISPLAY_CONSENT_FORMS_ON_KIOSK',
  FOLLOW_UP_QUESTIONS = 'FOLLOW_UP_QUESTIONS',
  IPO_M2B_BRAINTREE_SIGNUP = 'IPO-M2B_BRAINTREE_SIGNUP',
  INPUT_FORMS_DOCUMENT = 'INPUT_FORMS_DOCUMENT',
  SMS_CONSENT_TOGGLE = 'SMS_CONSENT_TOGGLE',
  SUPPRESS_ADD_CLIENTS_AND_PATIENTS = 'SUPPRESS_ADD_CLIENTS_AND_PATIENTS',
  NEW_APPOINTMENT_BOOKING_FLOW_KIOSK = 'NEW_APPOINTMENT_BOOKING_FLOW_KIOSK',
  MEMBERSHIP_SIGNUP_TERMINAL = 'MEMBERSHIP_SIGNUP_TERMINAL',
}

export default Features
